import React from "react";
import { Modal } from "react-bootstrap";
import { useModalDismiss } from "./useModalDismiss";

interface Props {
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    danger?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export default function ConfirmModal({
    title,
    message,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    danger = false,
    onConfirm,
    onCancel,
}: Props) {
    const { show, dismiss, onExited } = useModalDismiss(onCancel, onConfirm);

    return (
        <Modal show={show} onHide={() => dismiss("cancel")} onExited={onExited} centered backdropClassName="m-modal-backdrop">
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: 17, fontWeight: 600 }}>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ fontSize: 14, color: "#334155", margin: 0 }}>{message}</p>
            </Modal.Body>
            <Modal.Footer>
                <button className="m-btn m-btn-ghost" onClick={() => dismiss("cancel")}>{cancelLabel}</button>
                <button
                    className={`m-btn ${danger ? "m-btn-danger" : "m-btn-primary"}`}
                    onClick={() => dismiss("save")}
                >
                    {confirmLabel}
                </button>
            </Modal.Footer>
        </Modal>
    );
}
